(function(window, document, $) {

	main = function(){

		var body = $('body'),
		button_menu_mobile = $('.button-menu-mobile'),
		mobile_menu_is_open = false,
		button_more_posts = $('.button_more_posts'),
		more_posts_offset = button_more_posts.data('offset'),
		posts_per_page = button_more_posts.data('posts_per_page'),
		thumbs_wrapper = $('.post_results .thumbs ul'),
		loading_more_posts = false,
		button_expandable_text = $('.middin_el_expandable_text .middin_el_title'),

		dg_swiper_images = $('.dg_swiper_images .swiper-container'),

		init = function(){

			var swiper_homepage = new Swiper('.middin-homepage-swiper .swiper-container', {
				prevButton: '.swiper-button-prev',
				nextButton: '.swiper-button-next',
				slidesPerView: '1',
				centeredSlides: true,
				spaceBetween: 0,
				autoplay: 5000,
				speed: 1200,
				shortSwipes: true,
				paginationClickable: false,
				loop: true,
				lazyLoadingInPrevNext: true,
				watchSlidesProgress: true,
				effect: 'fade',

				breakpoints: {
					1100: {
						speed: 500,
					},
					650: {

						prevButton: false,
						nextButton: false,
						speed: 300,
					},
				}
			});

			var swiper_posts = new Swiper('.swiper-posts .swiper-container', {
				prevButton: '.swiper-button-prev',
				nextButton: '.swiper-button-next',
				slidesPerView: '3',
				spaceBetween: 20,
				// autoplay: 5000,
				speed: 600,
				shortSwipes: true,
				paginationClickable: false,
				loop: false,
				lazyLoadingInPrevNext: true,
				watchSlidesProgress: true,

				breakpoints: {
					1000: {
						speed: 500,
						slidesPerView: '2',
					},
					650: {

						slidesPerView: '1',
					},
				}
			});

			if(dg_swiper_images.length)
			{
				_create_image_swipers();
			}

			$('.card-post-equal').equalHeights();
			$('.poll_column').equalHeights();

			button_menu_mobile.on( 'click' , _toggle_mobile_menu);
			button_more_posts.on( 'click' , _load_more_posts);
			button_expandable_text.on( 'click' , _toggle_expandable_text);
		},
		_toggle_expandable_text = function()
		{
			var el = $(this).closest( ".middin_el_expandable_text" );
			el.toggleClass('open');
		},
		_load_more_posts = function()
		{
			if(!loading_more_posts)
			{
				loading_more_posts = true;
				$.ajax({
					url: ajax.ajaxurl,
					type: 'post',
					data: {
						action: 'load_more_posts',
            			post_offset : more_posts_offset,
            			posts_per_page : posts_per_page
					},
					success: function( result ) {

						// console.log( result );

						if(!result || result === 0)
						{
							button_more_posts.css('display', 'none');
						}
						else
						{
							var parsed_result = JSON.parse(result);

							// console.log("parsed_result.post_count ", parsed_result.post_count);
							// console.log("parsed_result.more_to_load ", parsed_result.more_to_load);
							// console.log("parsed_result.content ", parsed_result.content);

							if(parsed_result.post_count >= 1)
							{
								thumbs_wrapper.append( parsed_result.content );
								$('.card-post-equal').equalHeights();

								more_posts_offset += parsed_result.post_count;

								// console.log("more_posts_offset ", more_posts_offset);
							}
							if(parsed_result.more_to_load < 1)
							{
								button_more_posts.css('display', 'none');
							}
						}

						loading_more_posts = false;
					}
				});
			}
		},
		_toggle_mobile_menu = function()
		{
			body.toggleClass('menu-open-mobile');
		},
		_create_image_swipers = function()
		{
			for (var i = dg_swiper_images.length - 1; i >= 0; i--)
			{
				var swiper_div = dg_swiper_images[i];
				var swiper_effect = 'slide';
				var data_effect = $(swiper).attr('data-effect');
				if(data_effect)
				{
					swiper_effect = data_effect;
				}

				var swiper = new Swiper( swiper_div, {
					pagination: '.swiper-pagination',
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					slidesPerView: '1',
					effect: swiper_effect,
					centeredSlides: true,
					paginationClickable: true,
					spaceBetween: 0,
					autoplay: 4000,
					speed: 800,
					loop: true,
					shortSwipes: true,
					autoplayDisableOnInteraction: true,
					grabCursor: true,
					lazyLoadingInPrevNext: true,
					breakpoints: {
						1100: {
							speed: 500,
						},
						650: {

							speed: 300,
						},
					}
				});
			}
		};

		return{ init:init };
	}();
	main.init();

})(window, document, jQuery);